import { render } from "./CarouselNavigation.vue?vue&type=template&id=15a09bc6"
import script from "./CarouselNavigation.vue?vue&type=script&lang=js"
export * from "./CarouselNavigation.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/mdbvue/Advanced/CarouselNavigation.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "15a09bc6"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('15a09bc6', __exports__)) {
    api.reload('15a09bc6', __exports__)
  }
  
  module.hot.accept("./CarouselNavigation.vue?vue&type=template&id=15a09bc6", () => {
    api.rerender('15a09bc6', render)
  })

}


export default __exports__